var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescendingHovered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=descending, states=hovered"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.31854 7.80037L9.32543 12.5348C9.54688 12.7965 9.65761 12.9273 9.80206 12.9713C9.92807 13.0096 10.0719 13.0096 10.1979 12.9713C10.3424 12.9273 10.4531 12.7965 10.6746 12.5348L14.6815 7.80037C14.9037 7.53777 15.0148 7.40646 14.9984 7.2987C14.9841 7.20471 14.9121 7.11929 14.8004 7.06372C14.6723 7 14.4505 7 14.0069 7H5.99311C5.54953 7 5.32774 7 5.19964 7.06372C5.0879 7.11929 5.01592 7.20471 5.00159 7.2987C4.98517 7.40646 5.09629 7.53777 5.31854 7.80037Z",
    stroke: "#218BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescendingHovered);
export default __webpack_public_path__ + "static/media/descending-hovered.cf5e0ea44ba5a46fef552ce6592d29f3.svg";
export { ForwardRef as ReactComponent };